import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import { Alignment } from '@ckeditor/ckeditor5-alignment';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { FontBackgroundColor, FontColor, FontFamily, FontSize } from '@ckeditor/ckeditor5-font';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Highlight } from '@ckeditor/ckeditor5-highlight';
import {
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload
} from '@ckeditor/ckeditor5-image';

import { Indent } from '@ckeditor/ckeditor5-indent';
import { Bold, Italic, Strikethrough, Underline } from '@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Link, LinkImage } from '@ckeditor/ckeditor5-link';
import { List, ListUI } from '@ckeditor/ckeditor5-list';
import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
import { Table, TableToolbar } from '@ckeditor/ckeditor5-table';
import { SpecialCharacters } from '@ckeditor/ckeditor5-special-characters';
import { HorizontalLine } from '@ckeditor/ckeditor5-horizontal-line';
import { SimpleUploadAdapter } from '@ckeditor/ckeditor5-upload';
import { routes } from './routes';
import '@ckeditor/ckeditor5-build-classic/build/translations/nl';
import '@ckeditor/ckeditor5-build-classic/build/translations/en-gb';

class ApprenticeEditor extends ClassicEditorBase {
}

ApprenticeEditor.builtinPlugins = [
    Alignment,
    Bold,
    BlockQuote,
    List,
    ListUI,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    Heading,
    Highlight,
    HorizontalLine,
    Image,
    ImageToolbar,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageUpload,
    LinkImage,
    Indent,
    Table,
    TableToolbar,
    Italic,
    Link,
    MediaEmbed,
    Underline,
    SpecialCharacters,
    Strikethrough,
    SimpleUploadAdapter
];

ApprenticeEditor.defaultConfig = {
    licenseKey: 'GPL',
    toolbar: {
        shouldNotGroupWhenFull: true
    },
    mediaEmbed: {
        previewsInData: true
    },
    simpleUpload: {
        withCredentials: true,
        headers: {
            'X-CSRF-TOKEN': csrfToken
        },
        uploadUrl: routes.baseUrl() + '/editor-image/upload'
    },
    language: 'nl',
    link: {
        addTargetToExternalLinks: true
    },
    image: {
        toolbar: [
            'imageResize:original',
            'imageResize:25',
            'imageResize:50',
            'imageResize:75',
            '|',
            'imageStyle:alignLeft',
            'imageStyle:alignRight',
            'imageStyle:alignCenter',
            '|',
            'imageTextAlternative'
        ],
        upload: {
            types: ['jpeg', 'png', 'gif', 'jpg']
        },
        resizeUnit: '%',
        resizeOptions: [
            {
                name: 'imageResize:original',
                value: null,
                icon: 'original'
            },
            {
                name: 'imageResize:25',
                value: '25',
                icon: 'small'
            },
            {
                name: 'imageResize:50',
                value: '50',
                icon: 'medium'
            },
            {
                name: 'imageResize:75',
                value: '75',
                icon: 'large'
            }
        ]
    }
};

export default ApprenticeEditor;

